import React from 'react';
import styled from 'styled-components';
import { remCalc } from '@lux/helpers';

import Anchor from '../Anchor';
import Grid from '../Grid';
import Column from '../Column';
import List from '../List';
import ListItem from '../ListItem';
import Row from '../Row';

import Theme from '../../theme';

const SCAnchorBlack = styled(Anchor)`
  color: ${Theme.colours.black};
  font-size: ${Theme.fonts.sizes.small};
  display: block;

  &:not([disabled]) {
    &:hover {
      color: ${Theme.colours.black};
    }
  }

  & svg {
    float: right;
  }
`;

const SCAnchorBlackPrimary = styled(SCAnchorBlack)`
  display: block;
  line-height: ${remCalc(64)};
  padding: 0 0 0 ${remCalc(20)};
  font-size: ${Theme.fonts.sizes.regular};
  position: relative;
  transition: all 0.3s ease;
  cursor: ${p => (p.href ? 'pointer' : 'default')};
  color: ${p => (p.active ? Theme.colours.singtelred : Theme.colours.black)};

  &:not([disabled]):hover {
    color: ${p => (p.active ? Theme.colours.singtelred : Theme.colours.black)};
  }
`;

const SecondaryDesktop = styled.div`
  width: 100%;
  background-color: ${Theme.colours.white};
  box-shadow: 1px 2px 10px 1px ${Theme.colours.grey_d6};
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 99999;
`;

const SCSecondaryMenuDesktopColumn = styled(Column)`
  padding: ${remCalc(30)};
  padding-left: ${p => (p.index === 0 ? remCalc(10) : remCalc(30))};
  border-right: 1px solid ${Theme.colours.grey_e2};
`;

const DesktopMenu = ({
  menuItems,
  menuHoverKey,
  onMenuMouseEnter,
  onMenuMouseLeave
}) => {
  return menuItems.map((menuItem, key) => {
    const showSecondaryMenu =
      menuHoverKey === key && menuItem.subMenu && menuItem.subMenu.length > 0;

    return (
      <div
        key={key}
        onMouseEnter={() => onMenuMouseEnter(key)}
        onMouseLeave={() => onMenuMouseLeave(key)}
      >
        <ListItem key={key}>
          {/* Primary navigation items */}
          <SCAnchorBlackPrimary
            active={menuItem.item.active}
            href={menuItem.item.href}
          >
            {menuItem.item.title}
          </SCAnchorBlackPrimary>
        </ListItem>
        {/* When user hovers over a primary navigation item */}
        {showSecondaryMenu && (
          <SecondaryDesktop>
            <Grid>
              <Row>
                {/* Loop through second level items */}
                {(menuItem.subMenu || []).map((subMenuItem, key) => {
                  return (
                    <SCSecondaryMenuDesktopColumn sm key={key} index={key}>
                      <SCAnchorBlack>{subMenuItem.item.title}</SCAnchorBlack>
                      <List noPadding showBullets={false}>
                        {/* Loop through third level items */}
                        {(subMenuItem.subMenu || []).map(
                          (subSubMenuItem, key) => {
                            return (
                              <ListItem key={key}>
                                <SCAnchorBlack
                                  secondary
                                  href={subSubMenuItem.item.href}
                                >
                                  {subSubMenuItem.item.title}
                                </SCAnchorBlack>
                              </ListItem>
                            );
                          }
                        )}
                      </List>
                    </SCSecondaryMenuDesktopColumn>
                  );
                })}
              </Row>
            </Grid>
          </SecondaryDesktop>
        )}
      </div>
    );
  });
};

export default DesktopMenu;
